/**
 * Centralized tracking configurations
 *
 * These constants are defined outside of React components to ensure stable references
 * and prevent unnecessary re-renders. Each configuration object maintains the same
 * reference across renders, optimizing React's reconciliation process.
 */

// Roster Management Alert Tracking Configurations
// https://rvohealth.atlassian.net/wiki/spaces/PA/pages/1796669443/Roster
export const REMOVE_ROSTER_PROVIDER_ALERT_TRACKING = {
  view: {
    webElement: {
      elementType: 'Alert View',
      location: 'Roster',
      name: 'Remove Roster Provider',
    },
  },
  cancelButton: {
    actionOutcome: 'Cancel',
    webElement: {
      elementType: 'Button',
      location: 'Roster',
      name: 'Remove Roster Provider',
    },
  },
  closeButton: {
    actionOutcome: 'Close',
    webElement: {
      elementType: 'Button',
      location: 'Roster',
      name: 'Remove Roster Provider',
    },
  },
  confirmButton: {
    actionOutcome: 'Remove',
    webElement: {
      elementType: 'Button',
      location: 'Roster',
      name: 'Remove Roster Provider',
    },
  },
};
